<template>
	<eg-modal
		scrollable
		:height="'500px'"
		:width="'400px'"
		:show="show"
		@close="close()"
	>
		<p class="center" slot="header">
			<b>Convidar</b>
		</p>
		<div slot="body" class="row">
			<eg-alert
				:show="showAlert"
				:message="message"
				color="red"
				@show="showAlert = $event"
			/>
			<p>
				Insira abaixo as informações do fornecedor que você gostaria que
				participasse da cotação.
			</p>
			<div class="col xl12 l12 m12 s12">
				<div class="input-field">
					<eg-input
						:value="supplierTradingName"
						v-model="supplierTradingName"
						name="name"
						placeholder-text="Nome fantasia*"
						title="Nome fantasia"
						:valid="valid"
						:rules="textRules"
						@valid="textRules.valid = $event"
					/>
				</div>
			</div>
			<div class="col xl12 l12 m12 s12">
				<div class="input-field">
					<eg-input
						:value="supplierEmail"
						v-model="supplierEmail"
						name="email"
						placeholder-text="Email*"
						title="Email"
						:valid="valid"
						:rules="emailRules"
						@valid="emailRules.valid = $event"
					/>
				</div>
			</div>
			<div class="col xl12 l12 m12 s12">
				<div class="input-field">
					<eg-input
						:value="supplierPhone"
						v-model="supplierPhone"
						:mask="['(##) #####-####', '(##) ####-####']"
						name="tel"
						placeholder-text="Telefone"
						title="Telefone"
						:valid="valid"
						:rules="phoneRules"
						@valid="phoneRules.valid = $event"
					/>
				</div>
			</div>
			<div class="col xl12 l12 m12 s12">
				<div class="input-field">
					<eg-input
						link
						:value="supplierWebsite"
						v-model="supplierWebsite"
						name="name"
						placeholder-text="Website"
						title="Website"
					/>
				</div>
			</div>
		</div>
		<a
			id="invite-suppliers-footer"
			:disabled="!formValid"
			@click="validateForm"
			slot="footer"
			class="btn blue darken-4"
			>Adicionar</a
		>
	</eg-modal>
</template>

<script>
export default {
    name: 'InviteSuppliersModal',
    data: () => ({
        notificationModal: false,
        valid: false,
        showAlert: false,
        supplierEmail: '',
        message: '',
        supplierPhone: '',
        supplierTradingName: '',
        supplierWebsite: '',
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true,
        },
        phoneRules: {
            name: '',
            type: 'text',
            length: 8,
            required: false,
            valid: true,
        },
        emailRules: {
            name: 'E-mail',
            type: 'email',
            required: true,
            valid: true,
        },
    }),
    props: {
        show: Boolean,
    },
    methods: {
        close() {
            this.$emit('close', false);
        },
        async validateForm() {
            this.valid = !this.valid;
            await setTimeout(() => {}, 1000);
            if (this.validateForm) {
                const data = {
                    email: this.supplierEmail,
                    phone: this.supplierPhone,
                    tradingName: this.supplierTradingName,
                    website: this.supplierWebsite,
                };
                this.$emit('add-supplier', data);
            } else {
                this.message = 'Preencha os campos obrigatórios';
                this.showAlert = true;
                window.scrollTo(0, 0);
            }
        },
    },
    computed: {
        formValid() {
            return this.emailRules.valid && this.textRules.valid ? true : false;
        },
    },
};
</script>

<style></style>
